import { Avatar } from 'antd'
import React from 'react'

type OrganisationAvatarProps = {
  name: string | undefined | null
}

const OrganisationAvatar: React.FC<OrganisationAvatarProps> = ({ name = '' }) => {
  const orgInitials = (name ?? '')
    ?.split(' ')
    .map((e) => e[0])
    .join('')
  return (
    <Avatar size={'small'} style={{ backgroundColor: 'var(--primary-400)', minWidth: 25 }}>
      {orgInitials}
    </Avatar>
  )
}

export default OrganisationAvatar
